/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useRef, useState, useEffect, useCallback } from "react";
import { SuburbList } from "../lib/OptionsAPI";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Button } from "./ui/button";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "./ui/command";
import { CheckIcon, XIcon } from "lucide-react";
import { cn } from "../lib/utils";
import { CaretSortIcon } from "@radix-ui/react-icons";
import { debounce } from "lodash";

const SuburbSelect = ({
  state_id,
  frameworkData,
  optionType,
  handleSelect,
  handleBlur,
  className,
  disabled = false,
  initialValue,
  setSuburbList,
  setSuburbLoading,
  onClear,
  loading
}) => {
  const frameworks = frameworkData.filter(
    (item, index, self) =>
      index === self.findIndex((t) => t.label === item.label)
  );
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(initialValue);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [searchTerm, setSearchTerm] = useState(""); // Store search input
  const scrollRef = useRef(null); // Ref for tracking scrolling

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  // Function to load more suburbs

  const isLoadingMoreRef = useRef(false); // Prevent concurrent calls

  const loadMore = async () => {
    if (!hasMore || isLoadingMoreRef.current) return;

    isLoadingMoreRef.current = true;
    const nextPage = page + 1;

    const moreData = await SuburbList(
      state_id,
      page + 1,
      setSuburbLoading,
      setSuburbList,
      true
    );
    setPage(nextPage);
    setHasMore(moreData);

    isLoadingMoreRef.current = false;
  };

  // Manual scroll detection
  const handleScroll = useCallback(
    debounce(() => {
      if (!scrollRef.current) return;

      const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;

      if (scrollTop + clientHeight >= scrollHeight - 10) {
        loadMore();
      }
    }, 200), // 200ms debounce
    [page, hasMore]
  );

  const fetchSuburbs = useCallback(
    debounce(async (query) => {
      setPage(1); // Reset pagination on new search
      setHasMore(true);
      const moreData = await SuburbList(
        state_id,
        1, // Start from page 1 on new search
        setSuburbLoading,
        setSuburbList,
        true, // Replace list on new search
        query // Pass the search query
      );
      setHasMore(moreData);
    }, 500), // 500ms delay
    [state_id]
  );

  useEffect(() => {
    fetchSuburbs();
  }, [state_id, fetchSuburbs]);

  const handleSearch = (e) => {
    const query = e;
    setSearchTerm(query);
    fetchSuburbs(query);
  };

  //   useEffect(() => {
  //   const el = scrollRef.current;
  //   if (!el) return;

  //   const handleWheel = () => {
  //     // Trigger scroll manually
  //     handleScroll();
  //   };

  //   el.addEventListener("wheel", handleWheel);

  //   return () => {
  //     el.removeEventListener("wheel", handleWheel);
  //   };
  // }, [handleScroll]);

  const handleClear = (e) => {
    setValue("");
    onClear && onClear("");
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className={`w-full justify-between h-9 px-3 ${
            value
              ? "font-normal text-left overflow-hidden"
              : "text-muted-foreground font-normal"
          } ${className || ""}`}
          onBlur={handleBlur}
          disabled={disabled}
          title={
            value
              ? frameworks.find((framework) => framework?.value == value)?.label
              : ""
          }
        >
          <span className="truncate flex-1 min-w-0 text-left">
            {value
              ? frameworks.find((framework) => framework?.value == value)?.label
              : `Select ${optionType}...`}
          </span>
          {/* <CaretSortIcon className="ml-2 h-4 w-4 shrink-0 opacity-50" /> */}
          {value && !loading ? (
            <XIcon
              className="ml-2 h-4 w-4 shrink-0 cursor-pointer opacity-50"
              onClick={(event) => {
                event.stopPropagation();
                handleClear();
              }}
            />
          ) : (
            <CaretSortIcon className="ml-2 h-4 w-4 shrink-0 opacity-50" />
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className="w-full p-0"
        modal={false}
        onPointerDownOutside={(e) => e.stopPropagation()}
        onFocusOutside={(e) => e.preventDefault()}
        onWheelCapture={(e) => e.stopPropagation()}
      >
        <Command>
          <CommandInput
            placeholder={`Search ${optionType}...`}
            className="h-9"
            value={searchTerm}
            onValueChange={handleSearch}
            disablePointerSelection={!state_id}
          />
          <CommandList
            ref={scrollRef}
            onScroll={handleScroll} // Attach scroll event listener
            className="max-h-60 overflow-y-auto"
          >
            <CommandEmpty>No {optionType} found.</CommandEmpty>
            <CommandGroup>
              {frameworks.map((framework) => (
                <CommandItem
                  key={framework?.value}
                  value={framework?.label}
                  onSelect={(currentValue) => {
                    setOpen(false);
                    handleSelect(
                      frameworks.find(
                        (framework) => framework?.label === currentValue
                      )?.value
                    );
                    setValue(
                      frameworks.find(
                        (framework) => framework?.label === currentValue
                      )?.value
                    );
                  }}
                  disabled={disabled}
                  className={value === framework?.value ? "optionActive" : ""}
                >
                  {framework?.label}
                  <CheckIcon
                    className={cn(
                      "ml-auto h-4 w-4 optionChecked",
                      value === framework?.value ? "opacity-100" : "opacity-0"
                    )}
                  />
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};

export default SuburbSelect;
